export const APP_NAME = 'ventas-constructoras';
